import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, Typography } from "@mui/material";
import { useCardData } from "hooks/useCardData";
import React, { FC, memo } from "react";
import { Link } from "react-router-dom";


export const HomeCardSection: FC = memo(function HomeCardSection(): JSX.Element {
  const {
    data: { front } = {},
  } = useCardData();
  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
    <Grid size={{ xs: 12, md: 6 }} offset={{ xs: 0, md: 3 }}>
      <Box paddingY={4}>
        <Typography variant="h2" align="center">
          My Member ID Card
        </Typography>
      </Box>
      <Link to="id-card">
        {front ? (
          <Box
            sx={{
              border: 'rgba(76, 76, 79, 0.2) 1px solid',
              borderRadius: '23px',
            }}
            component="img"
            src={front}
            width="100%"
            alt="Access Card front side"
          />
        ) : (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "375px" }}
          >
            <FontAwesomeIcon
              icon={faCircleNotch}
              aria-label="Currently Loading Content"
              size="3x"
            />
          </div>
        )}
      </Link>
    </Grid>
  </Grid>
  );
});